export const FONT_FAMILY = 'Inter, sans-serif'